import * as actionTypes from '../actionTypes/Chat'

export const addMessage = message => {
    return {
        type: actionTypes.ADD_MESSAGE,
        message,
    }
}

export const setMessagesTabOpen = isOpen => {
    return {
        type: actionTypes.SET_MESSAGES_TAB_OPEN,
        isOpen,
    }
}
